/**
* Process Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Process Slider component.
*/

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    className: 'process-slider',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const slider = new Splide( this.selector() + ' .splide', {
        type: 'loop',
        perPage: 1,
        arrows: false,
        pagination: false,
        drag: true,
      } ).mount();

      this.setupCustomArrows( slider );

      $( this.selector() + ' .process-slider__steps-nav button' ).on( 'click', function() {
        const stepIndex = $( this ).data( 'step' );
        slider.go( stepIndex );
      } );

      slider.on( 'move', function( newIndex ) {
        $( COMPONENT.selector() + ' .process-slider__steps-nav button' ).removeClass( 'is-active' );
        $( COMPONENT.selector() + ' .process-slider__steps-nav button[data-step="' + newIndex + '"]' ).addClass( 'is-active' );
      } );

      $( this.selector() + ' .process-slider__steps-nav button:first-child' ).addClass( 'is-active' );
    },
    setupCustomArrows: function( slider ) {
      document.querySelector( '.process-slider__arrow--prev' ).addEventListener( 'click', function() {
        slider.go( '<' );
      } );

      document.querySelector( '.process-slider__arrow--next' ).addEventListener( 'click', function() {
        slider.go( '>' );
      } );
    },
  };

  app.registerComponent( 'process-slider', COMPONENT );
} )( app );
